import { SvgRemove } from "ui/svgs";
import { clsx } from "clsx";
import { REGION_INDEX_COLOR } from "lib/constants";

export default function RegionControlBtn({
  active,
  showDelete,
  index,
  title,
  onChange,
  onRemove,
}: {
  active: boolean;
  showDelete: boolean;
  index: number;
  title: string;
  onChange: (i: number) => void;
  onRemove?: (i: number) => void;
}) {
  return (
    <div
      className={clsx(
        `flex items-center justify-center relative h-10 w-[120px] px-1 bg-zinc-100 rounded-t-md border-t-2`,
        active
          ? "opacity-100 cursor-default"
          : "opacity-50 cursor-pointer hover:bg-zinc-200",
      )}
      onClick={() => {
        !active && onChange(index);
      }}
      style={{ borderColor: REGION_INDEX_COLOR[index] }}
    >
      {title} {index + 1}
      {showDelete && (
        <button
          onClick={() => {
            active && onRemove(index);
          }}
        >
          <SvgRemove
            width="20"
            className={clsx("fill-zinc-500 ", {
              "hover:fill-zinc-400": active,
            })}
          />
        </button>
      )}
    </div>
  );
}
